import { render, staticRenderFns } from "./allFirm.vue?vue&type=template&id=c9686124"
import script from "./allFirm.vue?vue&type=script&lang=ts"
export * from "./allFirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports